module.exports = __webpack_public_path__ + "static/snoken-x-47e9228ddd20a63972dd19b6f2f3d231.png";